import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const { t } = useTranslation();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const res = await register(email, password, name);
    setLoading(false);
    if (res.ok) {
      toast.success(t("success"));
      navigate("/dashboard");
    } else {
      toast.error(res.error || t("error"));
    }
  }

  return (
    <div className="min-h-[calc(100vh-4rem)] grid lg:grid-cols-2" data-testid="register-page">
      <div className="grid place-items-center p-8 order-2 lg:order-1">
        <form onSubmit={onSubmit} className="w-full max-w-md fade-up">
          <span className="eyebrow">{t("auth_register_title")}</span>
          <h1 className="hero-h2 text-3xl sm:text-4xl mt-2">{t("auth_register_title")}</h1>
          <p className="text-zinc-500 mt-2 text-sm">{t("auth_register_sub")}</p>

          <div className="mt-8 grid gap-5">
            <div className="grid gap-2">
              <Label htmlFor="name" className="eyebrow">{t("auth_name")}</Label>
              <Input id="name" required value={name} onChange={(e) => setName(e.target.value)}
                className="rounded-sm border-zinc-300 focus-visible:ring-black h-11" data-testid="register-name" />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="email" className="eyebrow">{t("auth_email")}</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="rounded-sm border-zinc-300 focus-visible:ring-black h-11" data-testid="register-email" />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="password" className="eyebrow">{t("auth_password")} (min. 6)</Label>
              <Input id="password" type="password" required minLength={6} value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="rounded-sm border-zinc-300 focus-visible:ring-black h-11" data-testid="register-password" />
            </div>
            <Button type="submit" disabled={loading}
              className="rounded-sm bg-black text-white hover:bg-zinc-800 h-11" data-testid="register-submit">
              {loading ? t("auth_loading") : t("cta_register")}
            </Button>
          </div>

          <p className="mt-6 text-sm text-zinc-500">
            {t("auth_have_account")}{" "}
            <Link to="/login" className="text-black underline underline-offset-4" data-testid="link-login">
              {t("cta_login")}
            </Link>
          </p>
        </form>
      </div>

      <div className="hidden lg:flex flex-col justify-between p-12 border-l border-zinc-200 bg-zinc-50 order-1 lg:order-2">
        <div>
          <span className="eyebrow">A2 — Sign up</span>
          <h2 className="hero-display text-6xl mt-6">Bienvenido.</h2>
          <p className="mt-6 text-zinc-600 font-light max-w-md">{t("tagline")}</p>
        </div>
        <div className="text-xs text-zinc-400 tracking-wider uppercase">© DocuConvert</div>
      </div>
    </div>
  );
}
